export const styles = {
  cursor: 'pointer',
  transition: t => t.transitions.curve.default,
  ':hover': {
    backgroundColor: 'interactiveBoxHover'
  }
};
